'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGettingStartedPageUrl = exports.getCmsRootUrl = exports.getAccountDashboardUrl = exports.getActiveQuoteUrl = exports.getPaidUserManagementUrl = exports.getCommunityUrl = exports.getHSFSApplicationURL = exports.getHSFSPurchaseUrl = exports.getHubspotForStartupsLandingPageUrl = exports.getProductsAndServicesCatalogUrl = exports.getSuiteLegalDisclaimerUrl = exports.getIndiaPromotionLandingPageUrl = exports.getProductTabUrl = exports.getPricingAndFeaturesPageUrl = exports.getPricingPageUrl = exports.getNotFoundUrl = exports.getRootUrl = exports.handleRedirect = undefined;

var _underscore = require('underscore');

var _getLang = require('I18n/utils/getLang');

var _getLang2 = _interopRequireDefault(_getLang);

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _params = require('hub-http/helpers/params');

var _url = require('hub-http/helpers/url');

var _publicPageUrls = require('./publicPageUrls');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var suffix = _enviro2.default.getShort() === 'qa' ? 'qa' : '';

var _createInternalUrl = function _createInternalUrl() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var query = arguments[1];

  var queryString = query && (0, _underscore.compact)(Object.values(query || {})).length ? '?' + (0, _params.stringify)(query) : '';
  var baseUrl = '/' + path;

  return '' + baseUrl + queryString;
};

var _createExternalUrl = function _createExternalUrl() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var query = arguments[1];

  var urlOptions = {
    protocol: 'https',
    hostname: 'app.hubspot' + suffix + '.com',
    path: path,
    query: (0, _params.stringify)(query)
  };

  return (0, _url.buildUrl)(urlOptions);
};

var handleRedirect = exports.handleRedirect = function handleRedirect(url) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

  setTimeout(function () {
    window.location = url;
  }, delay);
};

var getRootUrl = exports.getRootUrl = function getRootUrl() {
  return _createInternalUrl();
};

var getNotFoundUrl = exports.getNotFoundUrl = function getNotFoundUrl() {
  return _createInternalUrl('/not-found');
};

var getPricingPageUrl = exports.getPricingPageUrl = function getPricingPageUrl(primaryNavId, query) {
  return _createInternalUrl('' + primaryNavId, { query: query });
};

var getPricingAndFeaturesPageUrl = exports.getPricingAndFeaturesPageUrl = function getPricingAndFeaturesPageUrl(query) {
  return _createExternalUrl('/browse/' + _hubspot2.default.get(), query);
};

var getProductTabUrl = exports.getProductTabUrl = function getProductTabUrl(productsAndPlansNavId, query) {
  return _createInternalUrl('' + productsAndPlansNavId, {
    query: query
  });
};

var getLegalSiteDomain = function getLegalSiteDomain() {
  var localeToUrl = {
    en: 'https://legal.hubspot.com',
    de: 'https://legal.hubspot.com/de',
    es: 'https://legal.hubspot.com/es',
    pt: 'https://legal.hubspot.com/br',
    fr: 'https://legal.hubspot.com/fr',
    ja: 'https://legal.hubspot.com/jp'
  };

  var url = localeToUrl[(0, _getLang2.default)()];
  if (!url) {
    throw new Error('unknown localeToUrl mapping for lang: ' + (0, _getLang2.default)() + ', domain: legal');
  }

  return url;
};

var getIndiaPromotionLandingPageUrl = exports.getIndiaPromotionLandingPageUrl = function getIndiaPromotionLandingPageUrl() {
  var legalSiteDomain = getLegalSiteDomain();
  return legalSiteDomain + '/india-pricing-promotion';
};

var getSuiteLegalDisclaimerUrl = exports.getSuiteLegalDisclaimerUrl = function getSuiteLegalDisclaimerUrl() {
  var legalSiteDomain = getLegalSiteDomain();
  return legalSiteDomain + '/growth-suite-bundle-pricing';
};

var getProductsAndServicesCatalogUrl = exports.getProductsAndServicesCatalogUrl = function getProductsAndServicesCatalogUrl() {
  var section = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var legalSiteDomain = getLegalSiteDomain();
  return legalSiteDomain + '/hubspot-product-and-services-catalog' + section;
};

var getHubspotForStartupsLandingPageUrl = exports.getHubspotForStartupsLandingPageUrl = function getHubspotForStartupsLandingPageUrl(source) {
  var domain = (0, _publicPageUrls.getPublicSiteDomain)();

  return domain + '/startups?source=' + source;
};

var getHSFSPurchaseUrl = exports.getHSFSPurchaseUrl = function getHSFSPurchaseUrl() {
  return _createExternalUrl('/browse/' + _hubspot2.default.get() + '/select/hubspot-for-startups?via=pricing-page');
};

var getHSFSApplicationURL = exports.getHSFSApplicationURL = function getHSFSApplicationURL() {
  return _createExternalUrl('/hsfx-programs/' + _hubspot2.default.get() + '/application/company');
};

var getCommunityUrl = exports.getCommunityUrl = function getCommunityUrl() {
  return 'https://community.hubspot.com/';
};

var getPaidUserManagementUrl = exports.getPaidUserManagementUrl = function getPaidUserManagementUrl() {
  return _createExternalUrl('/settings/' + _hubspot2.default.get() + '/users/paid-users');
};

var getActiveQuoteUrl = exports.getActiveQuoteUrl = function getActiveQuoteUrl(quoteId) {
  return _createExternalUrl('/checkout/' + _hubspot2.default.get() + '/quotes/' + quoteId);
};

var getAccountDashboardUrl = exports.getAccountDashboardUrl = function getAccountDashboardUrl() {
  return _createExternalUrl('/account-and-billing/' + _hubspot2.default.get());
};

var getCmsRootUrl = exports.getCmsRootUrl = function getCmsRootUrl() {
  return _createExternalUrl('/marketplace/' + _hubspot2.default.get() + '/products?childType=LANDING_PAGE&childType=SITE_PAGE&subType=COS_TEMPLATE_PACK');
};

var getGettingStartedPageUrl = exports.getGettingStartedPageUrl = function getGettingStartedPageUrl() {
  return _createExternalUrl('/getting-started/' + _hubspot2.default.get());
};


//////////////////
// WEBPACK FOOTER
// ./js/utils/urls.js
// module id = 62
// module chunks = 3 4